/**
 * @(#)2019/11/16.
 * 文件上传封装 s3
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import { set } from "lodash";
import BaseUpload from "./baseUpload";
import { message } from "antd";
import request from "../request";
import { DB } from "../DB";
import { PostXhr } from "../baseRequest";
import { get, objToFormData, random, merge, cloneDeep } from "../index";

/**
 * 设立一个定时器清空缓存
 *
 */
const cleanLocal = (immediately = false) => {
  const timeList = [5 * 60 * 1000];
  const time = timeList.find((t) => t);
  if (immediately) {
    DB.set("s3", {});
  } else {
    setTimeout(() => DB.set("s3", {}), time);
  }
};

cleanLocal(true);

class UploadFileS3 extends BaseUpload {
  constructor(param) {
    super(param);
    const {
      policyUrl,
      tokenUrl,
      getFileUrl,
      uploadFileUrl,
      headers = {},
      url,
    } = param;
    const { prefix, policyName, maxRetry = 5 } = param;
    this.policyUrl = policyUrl || url;
    this.tokenUrl = tokenUrl;
    this.uploadFileUrl = uploadFileUrl;
    this.getFileUrl = getFileUrl;
    this.policy = null;
    this.s3Url = null;
    this.token = null;
    this.maxRetry = maxRetry || 5;
    this.retry = 0; // 重试机制
    this.prefixStr = prefix;
    this.uploadFileList = [];
    this.name = policyName;
    this.headers = merge({ ossType: " MINIO", headers });
  }

  get bucket() {
    return get(this.policy, "bucket", "");
  }

  get prefix() {
    const prefix = this.prefixStr;
    if (prefix == null) {
      return get(this.policy, "key", "").split("-")[0];
    }
    return prefix;
  }

  /**
   * 文件上传地址
   *
   * @readonly
   * @memberof UploadFileS3
   */
  get uploadUrl() {
    const url = this.uploadFileUrl + `/${this.bucket}`;
    return url;
  }

  static async new(...args) {
    const u = new this(...args);
    return u;
  }

  formParams = (file) => {
    const param = {
      ...this.policy,
      key: this.prefix + `-${file.name}`,
    };
    return merge(param, this.propsFormParams(file, param));
  };

  getLocalPolicy = () => {
    const sign = DB.get("s3");
    const policy = get(sign, "policy", null);
    if (policy != null) {
      return sign;
    }
    return null;
  };

  getPolicyContent = async (name) => {
    let result = null;
    const localPolicy = this.getLocalPolicy();
    if (localPolicy != null) {
      return localPolicy;
    } else {
      const param = {
        url: this.policyUrl,
        data: { name },
        headers: this.headers,
      };
      const policy = await this.requestPolicy(null, param);
      result = get(policy, "data", null) || policy;
      console.log("重新取值", result, this.policyUrl, param, policy);
      cleanLocal();
      return result;
    }
  };

  getSign = async (name, status) => {
    const name_ = name || this.name;
    const thatName = `${this.prefix}-${name_}`;
    let result = {};
    if (this.policy == null || status === "重试") {
      if (status === "重试") {
        DB.set("s3", {});
      }
      this.policy = await this.getPolicyContent(thatName);
      result = this.policy;
    } else {
      result = { ...this.policy };
      set(result, "key", thatName);
    }
    return result;
  };

  getFile = async (file) => {
    const name = get(file, "name", "");
    const url = this.getFileUrl;
    const res = await request({
      url,
      data: { objectName: `${this.prefix}-${name}` },
      headers: this.headers,
    });
    const fileUrl = get(res, "data", null) || res;
    const result = { uid: get(file, "uid", null), url: fileUrl, name };
    this.uploadFileList.push(result);
    return result;
  };

  sendFile = async (file) => {
    const url = this.uploadUrl;
    const param = this.formParams(file);
    const formData = objToFormData(param);
    formData.append("file", file);
    let result = await PostXhr.new(url, this.headers).xhrSend(formData);
    if (get(result, "status", null) === 403) {
      this.retry++;
      await this.uploadFile(file, "重试");
    }
  };

  uploadFile = async (file, status) => {
    if (this.retry > this.maxRetry) {
      this.retry = 0;
      message.error("上传失败，重试次数过多");
      return;
    }
    const name = get(file, "name", null);
    if (name == null) {
      console.warn("传入的必须是一个文件流", file);
    } else {
      this.policy = await this.getSign(name, status);
      await this.sendFile(file);
      return await this.getFile(file);
    }
    this.retry = 0;
  };
}

export default UploadFileS3;



// WEBPACK FOOTER //
// ./src/yx-widget/utils/upload/uploadFileS3.js